export class MessengerLauncher {
	constructor(state, options = {}) {
		this.state = state;
		this.options = {
			position: options.position || 'bottom-right',
			primaryColor: options.primaryColor || '#155EEF',
			...options,
		};
		this.element = null;
		this._unsubscribe = null;
	}

	render() {
		this.element = document.createElement('div');
		this.element.className = `messenger-launcher messenger-launcher-${this.options.position}`;

		this._updateContent();
		this._attachEvents();

		this._unsubscribe = this.state.subscribe((type, data) => {
			if (type === 'openChange') {
				this._updateIcon();
			}
			if (type === 'unreadCountChange') {
				this._updateBadge();
			}
		});

		return this.element;
	}

	_updateContent() {
		const badgeHtml =
			this.state.unreadCount > 0
				? `<span class="messenger-launcher-badge">${this.state.unreadCount > 9 ? '9+' : this.state.unreadCount}</span>`
				: '';

		this.element.innerHTML = `
        <button class="messenger-launcher-btn" aria-label="Open messenger">
            <span class="messenger-launcher-icon messenger-launcher-icon-chat">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256">
                    <path d="M144,140a12,12,0,1,1-12-12A12,12,0,0,1,144,140Zm44-12a12,12,0,1,0,12,12A12,12,0,0,0,188,128Zm51.34,83.47a16,16,0,0,1-19.87,19.87l-24.71-7.27A80,80,0,0,1,86.43,183.42a79,79,0,0,1-25.19-7.35l-24.71,7.27a16,16,0,0,1-19.87-19.87l7.27-24.71A80,80,0,1,1,169.58,72.59a80,80,0,0,1,62.49,114.17ZM81.3,166.3a79.94,79.94,0,0,1,70.38-93.87A64,64,0,0,0,39.55,134.19a8,8,0,0,1,.63,6L32,168l27.76-8.17a8,8,0,0,1,6,.63A63.45,63.45,0,0,0,81.3,166.3Zm135.15,15.89a64,64,0,1,0-26.26,26.26,8,8,0,0,1,6-.63L224,216l-8.17-27.76A8,8,0,0,1,216.45,182.19Z"></path>
                </svg>
            </span>
            <span class="messenger-launcher-icon messenger-launcher-icon-close" style="display: none;">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256">
                    <path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path>
                </svg>
            </span>
            ${badgeHtml}
        </button>
    `;

		const btn = this.element.querySelector('.messenger-launcher-btn');
		if (btn && this.options.primaryColor) {
			btn.style.setProperty(
				'background',
				this.options.primaryColor,
				'important'
			);
		}
	}

	_attachEvents() {
		this.element
			.querySelector('.messenger-launcher-btn')
			.addEventListener('click', () => {
				this.state.setOpen(!this.state.isOpen);
			});
	}

	_updateIcon() {
		const chatIcon = this.element.querySelector(
			'.messenger-launcher-icon-chat'
		);
		const closeIcon = this.element.querySelector(
			'.messenger-launcher-icon-close'
		);

		if (this.state.isOpen) {
			chatIcon.style.display = 'none';
			closeIcon.style.display = 'flex';
			this.element.classList.add('messenger-launcher-open');
		} else {
			chatIcon.style.display = 'flex';
			closeIcon.style.display = 'none';
			this.element.classList.remove('messenger-launcher-open');
		}
	}

	_updateBadge() {
		const existingBadge = this.element.querySelector(
			'.messenger-launcher-badge'
		);
		if (existingBadge) {
			existingBadge.remove();
		}

		if (this.state.unreadCount > 0 && !this.state.isOpen) {
			const badge = document.createElement('span');
			badge.className = 'messenger-launcher-badge';
			badge.textContent =
				this.state.unreadCount > 9 ? '9+' : this.state.unreadCount;
			this.element.querySelector('.messenger-launcher-btn').appendChild(badge);
		}
	}

	show() {
		if (this.element) {
			this.element.style.display = 'block';
		}
	}

	hide() {
		if (this.element) {
			this.element.style.display = 'none';
		}
	}

	destroy() {
		if (this._unsubscribe) {
			this._unsubscribe();
		}
		if (this.element && this.element.parentNode) {
			this.element.parentNode.removeChild(this.element);
		}
	}
}
